import { render, staticRenderFns } from "./DutyStatusColumnComponent.vue?vue&type=template&id=9d6ab284&"
import script from "./DutyStatusColumnComponent.vue?vue&type=script&lang=ts&"
export * from "./DutyStatusColumnComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d6ab284')) {
      api.createRecord('9d6ab284', component.options)
    } else {
      api.reload('9d6ab284', component.options)
    }
    module.hot.accept("./DutyStatusColumnComponent.vue?vue&type=template&id=9d6ab284&", function () {
      api.rerender('9d6ab284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/Gains/DutyStatusColumnComponent.vue"
export default component.exports